import React, { memo } from 'react';
import { NavLink } from 'react-router-dom';
import { StyledNavigation } from './Navigation.Styles';
export var Navigation = memo(function (_a) {
    var links = _a.links;
    return (React.createElement(StyledNavigation, null,
        React.createElement("ul", null, links.map(function (link, index) {
            return React.createElement("li", { key: index },
                React.createElement(NavLink, { to: link.link }, link.title));
        }))));
});
